import {
  Backdrop,
  Box,
  Button,
  Card,
  Fade,
  Grid,
  IconButton,
  makeStyles,
  Modal,
  Tooltip,
  Typography,
} from "@material-ui/core";

import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import PhotoIcon from "@mui/icons-material/Photo";

import componentStylesCardDeck from "assets/theme/components/cards/card-deck";
import componentStyles from "assets/theme/views";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import { useState } from "react";
import { IsMobile } from "utils/is-mobile";

const getTableColumns = (
  setSelectedProduct,
  setToggleFormDialog,
  setShowingPhoto
) => [
  {
    dataField: "idProduto",
    text: "Produto",
    sort: true,
  },
  {
    dataField: "name",
    text: "Descrição",
    sort: true,
  },
  {
    dataField: "quantidade",
    text: "Quantidade",
    sort: true,
  },
  {
    dataField: "motivo",
    text: "Motivo de Devolução",
    sort: true,
  },
  {
    dataField: "defeito",
    text: "Motivo de Defeito",
    sort: true,
  },
  {
    dataField: "images",
    text: "",
    align: "center",
    justifyContent: "center",
    formatter: (cell, row) => {
      if (!cell || cell.length === 0) {
        return;
      }

      return (
        <Tooltip title="Visualizar as imagens">
          <IconButton
            onClick={() =>
              setShowingPhoto({ images: cell, productName: row.name })
            }
          >
            <PhotoIcon
              style={{
                fontSize: 30,
                width: "20px",
                height: "20px",
                color: "#78777D",
              }}
            />
          </IconButton>
        </Tooltip>
      );
    },
  },
  {
    dataField: "editar",
    text: "",
    align: "center",
    justifyContent: "center",
    formatter: (cell, row) => {
      return (
        <Tooltip title="Editar produto">
          <IconButton
            aria-label="edit"
            onClick={() => {
              setSelectedProduct(row);
              setToggleFormDialog("edit");
            }}
          >
            <CreateIcon />
          </IconButton>
        </Tooltip>
      );
    },
  },
  {
    dataField: "deletar",
    text: "",
    align: "center",
    justifyContent: "center",
    formatter: (cell, row) => (
      <Tooltip title="Deletar produto">
        <IconButton
          aria-label="delete"
          onClick={() => {
            setSelectedProduct(row);
            setToggleFormDialog("delete");
          }}
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    ),
  },
];

const useStyles = makeStyles(componentStyles);
const useStylesCardDeck = makeStyles(componentStylesCardDeck);

export default function TableSolicitacaoDevolucao({
  products = [],
  setSelectedProduct,
  setToggleFormDialog,
}) {
  const [showingPhoto, setShowingPhoto] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const classes = { ...useStyles(), ...useStylesCardDeck() };
  const isMobile = IsMobile();

  console.log("products", products);

  const handleCloseModal = () => {
    setShowingPhoto(null);
    setCurrentImageIndex(0);
  };

  const handleNextImage = () => {
    if (showingPhoto && currentImageIndex < showingPhoto.images.length - 1) {
      setCurrentImageIndex(currentImageIndex + 1);
    }
  };

  const handlePrevImage = () => {
    if (currentImageIndex > 0) {
      setCurrentImageIndex(currentImageIndex - 1);
    }
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Card classes={{ root: classes.cardRoot }}>
            <ToolkitTable
              keyField="IdProduto"
              dataTable={products}
              columnModel={getTableColumns(
                setSelectedProduct,
                setToggleFormDialog,
                setShowingPhoto
              )}
              CustomHeader={() => (
                <Grid
                  container
                  className="pl-4"
                  style={{ padding: isMobile ? "0 24px 10px" : "0 24px" }}
                >
                  <Grid item xs={isMobile ? 12 : 4}>
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                      <Box component="span">Lista de Produtos</Box>
                    </Box>
                  </Grid>
                </Grid>
              )}
              pagination={{
                options: [25, 50, 100],
                defaultOption: 25,
              }}
            />
          </Card>
        </Grid>
      </Grid>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={Boolean(showingPhoto)}
        onClose={handleCloseModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        style={{
          display: "flex",
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Fade in={Boolean(showingPhoto)}>
          <div
            className={classes.paper}
            style={{
              backgroundColor: "#FFF",
              padding: "20px",
              borderRadius: 8,
              maxWidth: "90vw",
              maxHeight: "90vh",
              overflow: "auto",
            }}
          >
            <Box
              display="flex"
              justifyContent={isMobile ? "space-around" : "space-between"}
              marginBottom="1rem"
            >
              <Typography variant="h4" style={{ margin: 0 }}>
                {showingPhoto?.productName}
              </Typography>
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => setShowingPhoto(null)}
              >
                <Typography variant="caption">Fechar</Typography>
                <CloseIcon
                  onClick={() => setShowingPhoto(null)}
                  style={{ marginLeft: "0.5rem" }}
                />
              </Box>
            </Box>

            {showingPhoto &&
              showingPhoto.images &&
              showingPhoto.images.length > 0 && (
                <>
                  <Box
                    display="flex"
                    justifyContent="center"
                    marginBottom="1rem"
                  >
                    <img
                      alt={`Imagem ${currentImageIndex + 1}`}
                      src={
                        showingPhoto.images[currentImageIndex]?.base64 ||
                        showingPhoto.images[currentImageIndex]?.Url
                      }
                      style={{
                        width: "50vw",
                        maxHeight: "500px",
                        objectFit: "contain",
                      }}
                    />
                  </Box>

                  {showingPhoto.images.length > 1 && (
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      marginTop="1rem"
                    >
                      <Button
                        variant="outlined"
                        onClick={handlePrevImage}
                        disabled={currentImageIndex === 0}
                      >
                        Anterior
                      </Button>

                      <Typography variant="body2">
                        {currentImageIndex + 1} de {showingPhoto.images.length}
                      </Typography>

                      <Button
                        variant="outlined"
                        onClick={handleNextImage}
                        disabled={
                          currentImageIndex === showingPhoto.images.length - 1
                        }
                      >
                        Próxima
                      </Button>
                    </Box>
                  )}

                  <Box display="flex" justifyContent="center" marginTop="1rem">
                    <Typography variant="caption" color="textSecondary">
                      {showingPhoto.images[currentImageIndex].name}
                    </Typography>
                  </Box>
                </>
              )}
          </div>
        </Fade>
      </Modal>
    </>
  );
}
